module.exports = __webpack_public_path__ + "static/img/person.35741b7d.png";